import React, { Component } from 'react';
import { Button, Icon, Toast } from 'antd-mobile';
import {post} from '../../utils/request';
import { href, decode } from '../../utils/util';
import api from '../api';
import Cookies from 'js-cookie';
import JsBridge from '../../utils/jsBridge'
import './index.less';
var timer;
class IdentificationResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: '',
            status: 'loading',
            urlOps: {},
            backUrl: '',
            second: 5,
            secondType: false
        };
    }
    componentDidMount() {
        if(window.location.href.indexOf('?url') > -1){
            this.timeFN();
        }else{
            this.setState({
                status: 'success'
            },()=>{
                window.history.go(-window.history.length);
            });
        }
    }

    timeFN = () => {
        let _this = this;
        clearInterval(timer);
        this.setState({
            second: 5
        }, ()=>{
            let { second } = this.state;
            timer = setInterval(()=>{
                if(second < 0){
                    clearInterval(timer);
                    if(window.location.href.indexOf('?url') > -1){
                        var url1 = this.urlSplit(window.location.href);
                        const url = decode(url1.url);
                        var ops = this.urlSplit(url);
                        this.setState({
                            urlOps: ops,
                            backUrl: url//`${url.split('?')[0]}?userType=${ops.userType}&app_stoken=${ops.app_stoken}&mobileNumber=${ops.mobileNumber}`
                        },()=>{
                            this.checkCertification();
                        });
                    }else{
                        window.history.go(-window.history.length);
                    }
                }else{
                    _this.setState({
                        second: second--
                    });
                }
            },1000);
        });
    }

    urlSplit = (url)=>{
        var obj = '',obj1 = '',ops={};
        if(url.indexOf('?') > -1 ){
            obj = url.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
        }
        return ops;
    }

    checkCertification = ()=>{
        const { urlOps } = this.state;
        let _this = this;

        post({
            url: api.checkCertification + '?app_stoken=' + urlOps.app_stoken,
            data:{}
        }).then((res) => {
            console.log('校验是否实名', res)
            if(res.result === 'success'){
                if(!res.data.account){
                    this.setState({
                        status: 'error'
                    });
                }else{
                    this.setState({
                        status: 'success'
                    });
                }
            }else{
                if(res.code == '-1'){
                    Toast.info('登录失效',1);
                }else{
                    Toast.info('校验是否实名失败',1);
                }
            }
        }, (res)=>{
            console.log('校验是否实名失败', res)
            if(res.code == '-1'){
                Toast.info('登录失效',1);
            }else{
                Toast.info('校验是否实名失败',1);
            }
        });
    }
    
    render() {
        let { iconType, second, status } = this.state;
        const isAuth = window.location.href.indexOf('AUTH') > -1
        return (
            <div className="IdentificationResultBox">
                <div>
                    {status === 'error' ? (
                        <div className="error">
                            <div>
                                <Icon type="cross-circle-o" size="lg" />
                                <span>认证失败</span>
                            </div>
                            <Button type="primary" onClick={()=>{
                                window.location.href = this.state.backUrl;
                            }}>重新认证</Button>
                        </div>
                    ) : ''}

                    {status === 'success' ? (
                        <div className="success">
                            { 
                                isAuth ? <div> 
                                    <b className="resultIcon">!</b>
                                    <span>授权书认证已提交审核</span>
                                    <p>您已提交授权书认证，认证信息审核中，审核结果将于48小时内短信通知您</p>
                                    <Button type="primary" style={{ color: '#fff', marginTop:'10px'}} onClick={()=>{
                                        JsBridge('jumpRealNameInfo')
                                    }}>确认</Button>
                                </div>:<div>
                                    <Icon type="check-circle" size="lg" />
                                    <span>认证成功</span>
                                    <p>您已成功完成实名认证！</p>
                                </div>
                            }
                            
                        </div>
                    ) : ''}

                    {status === 'loading' ? (
                        <div className="loading">
                            <div>
                                <i></i>
                                <span>实名认证中</span>
                                <p>请耐心等待 <span>{second}</span> 秒</p>
                            </div>
                        </div>
                    ) : ''}
                </div>
            </div>
        );
    }
}

export default IdentificationResult;


// WEBPACK FOOTER //
// ./src/identityVerification/result/index.js